import { useState } from "react";
import { MessageSquare, Send, CheckCircle } from "lucide-react";
import API from "../../api";
import "./settings.css";

export default function FeedbackSettings() {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const submitFeedback = async () => {
    if (!message.trim()) {
      alert("Please enter your feedback");
      return;
    }

    try {
      setLoading(true);
      setSubmitted(false);

      await API.post("/feedback", {
        message: message.trim(),
      });

      setMessage("");
      setSubmitted(true);

      setTimeout(() => {
        setSubmitted(false);
      }, 3000);
    } catch (err) {
      console.error("Feedback error:", err);
      alert("Failed to submit feedback");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="settings-card feedback-settings">

      <div className="card-header">
        <div className="feedback-title">
          <div className="feedback-icon">
            <MessageSquare size={19} />
          </div>

          <div>
            <h3>Feedback</h3>
            <p>Help us improve Civilink</p>
          </div>
        </div>
      </div>

      <div className="feedback-body">

        <textarea
          className="textarea feedback-textarea"
          placeholder="Share your feedback, suggestions, or ideas..."
          value={message}
          onChange={(e) => {
            setMessage(e.target.value);
            setSubmitted(false);
          }}
          disabled={loading}
          maxLength={1000}
        />

        <div className="feedback-bottom">

          <span className="feedback-counter">
            {message.length}/1000
          </span>

          <button
            type="button"
            className="btn-primary feedback-submit"
            onClick={submitFeedback}
            disabled={loading || !message.trim()}
          >
            {submitted ? (
              <>
                <CheckCircle size={17} />
                Submitted
              </>
            ) : loading ? (
              <>
                <span className="feedback-spinner" />
                Sending...
              </>
            ) : (
              <>
                <Send size={17} />
                Send feedback
              </>
            )}
          </button>

        </div>

      </div>

    </section>
  );
}